import { datadogLogs } from '@datadog/browser-logs';
import { Helpers } from '@/services/helpers';
import { LOG_SEVERITY } from '../domain/logger.constants';
let loggerInstance = null;
const createClientLogger = () => {
    const desiredLogger = !Helpers.isProduction || process.env.CI || process.env.IS_CI ? console : datadogLogs.logger;
    const log = (message, metadata, severity) => {
        desiredLogger[severity](message, {
            data: {
                jsonPayload: {
                    message,
                    metadata,
                },
            },
        });
    };
    return {
        log: (message, metadata) => log(message, metadata, LOG_SEVERITY.INFO),
        debug: (message, metadata) => log(message, metadata, LOG_SEVERITY.DEBUG),
        info: (message, metadata) => log(message, metadata, LOG_SEVERITY.INFO),
        warn: (message, metadata) => log(message, metadata, LOG_SEVERITY.WARN),
        error: (message, metadata) => log(message, metadata, LOG_SEVERITY.ERROR),
    };
};
const createServerLogger = () => {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { getServerLogger } = require('./serverLogger');
    return getServerLogger();
};
const createLoggerService = () => {
    const logger = process.server ? createServerLogger() : createClientLogger();
    return { logger };
};
export const getLoggerService = () => {
    if (!loggerInstance) {
        loggerInstance = createLoggerService();
    }
    return loggerInstance;
};
